"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _createStyles = require("../styles/createStyles");
const _excluded = ["classes", "component", "isVisibleOnFocus", "className"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _createStyles.createStyles)({
  visuallyHidden: {
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: '-1px',
    padding: 0,
    border: 0,
    clip: 'rect(0 0 0 0)',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    wordWrap: 'normal'
  },
  visuallyHiddenFocusable: {
    '&:not(:focus):not(:focus-within)': {
      position: 'absolute',
      width: '1px',
      height: '1px',
      margin: '-1px',
      padding: 0,
      border: 0,
      clip: 'rect(0 0 0 0)',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      wordWrap: 'normal'
    }
  }
});
/**
 * **❗️ DEPRECATED**: Use `sr-only` class from Tailwind instead.
 *
 * @deprecated
 */
const VisuallyHidden = /*#__PURE__*/React.forwardRef(function VisuallyHidden(props, ref) {
  const {
      classes: classesOverrides,
      component: Component = 'span',
      isVisibleOnFocus,
      className
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    cx,
    classes
  } = useStyles({
    classesOverrides
  });
  const rootClasses = cx({
    [classes.visuallyHiddenFocusable]: isVisibleOnFocus,
    [classes.visuallyHidden]: !isVisibleOnFocus
  }, className);
  return /*#__PURE__*/React.createElement(Component
  // @ts-ignore TS2590
  , (0, _extends2.default)({
    className: rootClasses,
    ref: ref
  }, other));
});
var _default = exports.default = VisuallyHidden;